import { UseInvestorStore } from '@/app/store/investor.store';
import { env } from '@/env';
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { getSession, signOut } from 'next-auth/react';

export const azureBlobServer = axios.create();

export const serverWithoutInterceptor = axios.create({
  baseURL: env.NEXT_PUBLIC_API_URL,
  responseType: 'json',
  timeout: 300000,
});

export const serverExo = axios.create({
  baseURL: env.NEXT_PUBLIC_API_URL_EXO_API,
  responseType: 'json',
  timeout: 300000,
});

export const server = axios.create({
  baseURL: env.NEXT_PUBLIC_API_URL,
  responseType: 'json',
  timeout: 300000,
});

export const serverDiana = axios.create({
  baseURL: env.NEXT_PUBLIC_API_URL_DIANA,
  responseType: 'json',
  timeout: 300000,
});

export const serverDianaApi = axios.create({
  baseURL: env.NEXT_PUBLIC_API_URL_DIANA_API,
  responseType: 'json',
  timeout: 300000,
});

export const serverCreApi = axios.create({
  baseURL: env.NEXT_PUBLIC_API_URL_CRE_API,
  responseType: 'json',
  timeout: 300000,
});
// Request interceptor to add auth token
const requestInterceptor = async (config: InternalAxiosRequestConfig) => {
  const { isInvestor, investor } = UseInvestorStore.getState();
  let token: string | undefined;

  if (isInvestor) {
    token = investor.token;
  } else if (typeof window !== 'undefined') {
    const session = await getSession();
    token = session?.token;
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};

const requestErrorInterceptor = (error: AxiosError) => {
  return Promise.reject(error);
};

// Response interceptor to handle 401 errors
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const responseInterceptor = (response: any) => {
  return response;
};

const responseErrorInterceptor = async (error: AxiosError) => {
  if (error.response?.status === 401) {
    const { isInvestor } = UseInvestorStore.getState();

    if (isInvestor) {
      return Promise.reject(error);
    }

    if (typeof window === 'undefined') {
      return Promise.reject(error);
    }

    // Clear any local storage or session storage if needed
    localStorage.clear();
    sessionStorage.clear();

    // Sign out the user and redirect to login
    await signOut({
      callbackUrl: '/auth/login',
      redirect: true,
    });
  }

  return Promise.reject(error);
};

// Apply interceptors to serverExo
serverExo.interceptors.request.use(requestInterceptor, requestErrorInterceptor);

server.interceptors.request.use(requestInterceptor, requestErrorInterceptor);
serverExo.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

// Apply interceptors to serverDiana
serverDiana.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);
serverDiana.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

// Apply interceptors to serverDianaApi
serverDianaApi.interceptors.request.use(
  requestInterceptor,
  requestErrorInterceptor
);
serverDianaApi.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);
